var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { Container } from '../../../common/styles/container/styles/Container';
// Styles
import { boxShadows } from '../../../common/styles/boxShadows';
// Utils
import styled from 'styled-components';
export var TooltipContainer = styled(Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, showDirectionalArrow = _a.showDirectionalArrow, tooltipArrowBoxShadowSizing = _a.tooltipArrowBoxShadowSizing, tooltipArrowTop = _a.tooltipArrowTop, tooltipArrowLeft = _a.tooltipArrowLeft;
    return showDirectionalArrow &&
        "\n      &:before {\n        content: ' ';\n        display: block;\n        position: absolute;\n        width: 11px;\n        height: 11px;\n        background-color: " + theme.backgroundUI + ";\n        box-shadow: " + tooltipArrowBoxShadowSizing + " " + boxShadows[300] + ";\n        transform: rotate(45deg);\n        " + (tooltipArrowTop && "top: calc(" + tooltipArrowTop + " - 5.5px)") + ";\n        " + (tooltipArrowLeft && "left: calc(" + tooltipArrowLeft + " - 5.5px)") + ";\n      }\n    ";
});
var templateObject_1;
//# sourceMappingURL=TooltipContainer.js.map